'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'sword-laser';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e03b';
var svgPathData = ['M504.9689,7.02779a24.00309,24.00309,0,0,0-33.27442-.64061L225.58571,232.41472l53.986,53.985L505.60954,40.30626A23.99965,23.99965,0,0,0,504.9689,7.02779Z', 'M139.43866,293.34679l79.20154,79.19332,22.62566-22.62638L162.06823,270.7204Zm-33.9424,33.94055,79.19763,79.19333,22.62957-22.62639L128.12583,304.661Zm169.712-11.31417-79.19763-79.19332a8.00233,8.00233,0,0,0-11.31674,0L173.38106,248.094a7.99658,7.99658,0,0,0,0,11.31222l79.19763,79.19333a7.99763,7.99763,0,0,0,11.31283,0l11.31674-11.31222A8.006,8.006,0,0,0,275.20826,315.97317ZM9.36844,412.13482A32.00519,32.00519,0,0,0,9.35282,457.37l45.23179,45.27425a32.0792,32.0792,0,0,0,45.263.02344l79.20545-79.20309-90.51437-90.5075Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSwordLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;